import React from "react";
import { Paper, Grid } from "@mui/material";
import { Typography } from "../Wrappers/Wrappers";
import classnames from "classnames";
import { Expand, Collapse } from "../Fullscreen/FullScreen";
import useStyles from "./styles";

interface IWidget {
  children: React.ReactNode;
  title?: React.ReactNode;
  noTitleDivider?: boolean;
  titleClass?: string | Object;
  noBodyPadding?: string | Object;
  bodyClass?: string;
  widgetMenu?: React.ReactNode;
  header?: React.ReactNode;
  fullscreen?: string | boolean;
  collapse?: () => void;
  expand?: () => void;
  subtitle?: string | React.ReactNode;
  subTitleClass?: string | Object;
  customWidgetWrapperClass?: string;
  customPaperClass?: string;
  headerElementRight?: any;
  addBorder?: boolean;
  [key: string]: string | number | boolean | Object | React.ReactNode;
  dataTestId?: string;
  noPadding?:boolean;
  id?: string;
}

export default function Widget({
  children,
  title = undefined,
  noTitleDivider = false,
  titleClass = undefined,
  noBodyPadding = undefined,
  bodyClass = undefined,
  widgetMenu = <></>,
  header = undefined,
  fullscreen = undefined,
  collapse = () => {},
  expand = () => {},
  subtitle = undefined,
  subTitleClass = undefined,
  customWidgetWrapperClass = undefined,
  customPaperClass = undefined,
  headerElementRight,
  addBorder = false,
  dataTestId = "widget",
  noPadding = true,
  id = ""
}: IWidget) {
  const classes = useStyles();

  const isFullscreenApplicable = fullscreen !== undefined;
  const Fullscreen = () => {
    if (fullscreen) return <Collapse onClick={() => collapse()} />;
    else return <Expand onClick={() => expand()} />;
  };
  return (
    <div
      className={classnames(
        customWidgetWrapperClass ? customWidgetWrapperClass : classes.widgetWrapper,
        addBorder ? classes.widgetBorder : null,
      )}
      data-testid={dataTestId}
    >
      <Paper
        elevation={0}
        className={customPaperClass ? customPaperClass : classes.paper}
        classes={{ root: classes.widgetRoot }}
      >
        {!title && !header ? null : (
          <Grid className={!noTitleDivider && noPadding ? classes.widgetHeader : classes.widgetHeaderWithoutPadding}>
            {header || (
              <Grid className={classes.widgetHeaderTitle}>
                <Typography
                  className={titleClass || null}
                  variant="h1"
                  weight="bold"
                  data-testid={`${id}-title`}
                >
                  {title}
                </Typography>
                <Typography
                  variant="h6"
                  color="primary"
                  className={subTitleClass || null}
                  data-testid={`${id}-subtitle`}
                >
                  {subtitle}
                </Typography>
              </Grid>
            )}
            <Grid>{isFullscreenApplicable && <Fullscreen />}</Grid>
            {widgetMenu}
            {headerElementRight && <div>{headerElementRight}</div>}
          </Grid>
        )}
        <Grid
          className={ noPadding ? classnames(classes.widgetBody, {
            [classes.noPadding]: noBodyPadding,
            [bodyClass]: bodyClass,
          }) : classnames(classes.widgetBodyWithoutPadding, {
            [classes.noPadding]: noBodyPadding,
            [bodyClass]: bodyClass,
          })}
        >
          {children}
        </Grid>
      </Paper>
    </div>
  );
}
